<template>
  <grid-container-fi>
    <div
      :class="{
        'fact-finder-no-results-fi': true,
        'fact-finder-no-results-fi--category': isCategory,
      }"
    >
      <no-products-found-fi v-if="isCategory" />

      <template v-else>
        <div
          v-if="noFilters"
          class="fact-finder-no-results-fi__search"
          :class="{ 'fact-finder-no-results-fi__search-full': showResultSuggestion }"
        >
          <text-input-fi
            v-model.trim="search"
            :placeholder="$dict.get('search.No-Results.Placeholder')"
            icon="search"
            class="fact-finder-no-results-fi__input"
            @keyup-enter="$emit('new-search', search)"
            @icon-clicked="$emit('new-search', search)"
          />
        </div>
        <div
          v-if="!showResultSuggestion"
          :class="{
            'fact-finder-no-results-fi__content': true,
            'fact-finder-no-results-fi__content--no-filters': noFilters,
          }"
        >
          <richtext-fi
            class="fact-finder-no-results-fi__suggestions"
            :html-content="fields.noResultsSuggestions"
          />
        </div>
      </template>
    </div>
  </grid-container-fi>
</template>

<script setup lang="ts">
import { RichtextFi, TextInputFi } from 'atoms';
import { defineAsyncComponent, ref } from 'vue';

import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFields } from '@/composables/fields';

const NoProductsFoundFi = defineAsyncComponent(
  () => import('@/components/shop-modules/product-list-view/NoProductsFoundFi.vue'),
);

defineOptions({
  name: 'FactFinderNoResultsFi',
});

defineProps<{
  query?: string;
  noFilters?: boolean;
  showResultSuggestion?: boolean;
  isCategory?: boolean;
}>();

defineEmits<{
  'new-search': [value: string];
}>();

const fields = useFields('ProductCategoryFields');

const search = ref('');
</script>

<style scoped src="./fact-finder-no-results-fi" />
